<div class="tabTam">
  <div class="barMenu borderInf">
      <div class="menu">
        <div class="centradoVertical">
          <table>
            <tr>
              <td>
                <button mat-icon-button (click)="validacionTableros(menu)">
                  <mat-icon style="cursor: pointer;" [ngStyle]="{'color':'grey'}">menu</mat-icon>
                </button>
              </td>
              <td>
                <mat-icon class="logo" (click)="home()">
                  <img src="./../../../assets/img/logoaleema.png">
                </mat-icon>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="resto">
        <div class="w3-threequarter instituciones">
          <div class="centradoVertical">
            <span style="cursor: pointer;" (click)="obtenerSelect('cambio')">{{seleccion}}</span>
          </div>
        </div>
        <div class="contExit w3-center">
          <div class="centradoVertical">
            <table class="w3-table">
              <button mat-icon-button (click)="logOut()">
                <mat-icon [ngStyle]="{'color':'grey'}">exit_to_app</mat-icon>
              </button>
            </table>
          </div>
        </div>
        <div class="contInf borderDer">
            <div class="centradoVertical" style="width: 75%; float: left;">
              <span class="w3-right">{{dataService.user}}</span>
            </div>
            <div class="w3-center centradoVertical" style="margin-top: 0.5% !important;">
                <mat-icon [ngStyle]="{'color':'orange'}">face</mat-icon>
            </div>
        </div>
      </div>
  </div>
  <div class="w3-row contenedorTableros">
    <mat-drawer-container class="w3-row" style="height: 100%;">
      <mat-drawer #menu mode="over">
        <app-menu></app-menu>
      </mat-drawer>
      <div style="height: 100%; width: 100%; overflow: hidden;">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-container>
  </div>
</div>
